<template>
  <form
    :id="formId"
    method="post"
    class="form-horizontal"
    autocomplete="off"
    @submit.prevent
  >
    <h6 class="sub-section-title">
      {{ $t('registration.familyMemberInfo') }}
    </h6>

    <div class="row align-items-center">
      <label class="col-sm-3 control-label"> {{ $t('customerInfo.firstName') }}* </label>
      <div class="col-sm-4">
        <sanitized-input
          v-model="familyMember.firstName"
          required
        />
      </div>

      <label class="col-sm-2 control-label m-pt-10"> {{ $t('customerInfo.lastName') }}* </label>
      <div class="col-sm-3">
        <sanitized-input
          v-model="familyMember.lastName"
          required
        />
      </div>
    </div>

    <div class="row align-items-center">
      <label class="col-sm-3 control-label"> {{ $t('customerInfo.phoneNumber') }}* </label>
      <div class="col-sm-4">
        <phone-number-input
          v-model="familyMember.phoneNumber"
          :required="true"
        />
      </div>

      <label class="col-sm-2 control-label m-pt-10">
        {{ $t('customerInfo.email') }}
      </label>
      <div class="col-sm-3">
        <sanitized-input
          v-model="familyMember.email"
          type="email"
        />
      </div>
    </div>

    <div class="row align-items-center">
      <label class="col-sm-3 control-label"> {{ $t('lovedOne.relationship') }}* </label>
      <div class="col-sm-4">
        <dropdown-list
          v-model="familyMember.relationship"
          :options="familyRelationList"
          required
          filterable
        />
      </div>
    </div>

    <div class="row align-items-center">
      <div class="col-sm-5 offset-sm-3">
        <el-checkbox
          id="isFamilyNoSms"
          v-model="familyMember.transactionalSms"
        >
          {{ $t('lovedOne.doNotSendSafetyUpdates') }}
        </el-checkbox>
      </div>
    </div>

    <div class="row">
      <div class="col text-center">
        <p-button
          data-test="btn-get-customer"
          type="purple"
          native-type="submit"
          round
          :disabled="!isFormValid"
          :pressed="true"
          @click="onFormSubmit"
        >
          {{ $t('registration.next') }}
        </p-button>

        <p-button
          data-test="btn-skip"
          type="yellow"
          round
          :pressed="true"
          class="m-mt-10"
          @click="onSkip"
        >
          {{ $t('registration.skip') }}
        </p-button>
      </div>
    </div>
  </form>
</template>

<script lang="ts">
import { computed } from 'vue';

import util from '@/Utils/util';
import { familyRelationList } from '@/constants/lovedOne';

const formId = 'complete-registration-update-family-member-info';

export default {
  props: {
    familyMember: {
      type: Object,
      default: () => ({}),
    },
  },

  emits: ['submitClicked', 'skip'],

  setup: (props: any, context: any) => {
    const { emit } = context;

    const isFormValid = computed(() => {
      const requiredProperties: string[] = ['lastName', 'firstName', 'phoneNumber', 'relationship'];
      for (const property of requiredProperties) {
        if (!props.familyMember[property]) {
          return false;
        }
      }

      if (props.familyMember['email'] && !util.isValidEmailAddress(props.familyMember['email'])) {
        return false;
      }

      if (props.familyMember['phoneNumber'] && !util.isPhoneNumberValid(props.familyMember['phoneNumber'])) {
        return false;
      }

      return true;
    });

    const onFormSubmit = () => emit('submitClicked');
    const onSkip = () => emit('skip');

    return {
      formId,
      familyRelationList,
      isFormValid,

      onFormSubmit,
      onSkip,
    };
  },
};
</script>

<style scoped>
input:invalid {
  background-color: #fdf2b5;
  border: 1px solid #c7c98b !important;
}
</style>
